import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ApiService } from '../../services/api.service';
import { MessageService } from 'primeng/api';
import QRCode from 'qrcode';

@Component({
  selector: 'app-scheme-wise-route-popup',
  imports: [CommonModule, FormsModule, ReactiveFormsModule,DropdownModule],
  templateUrl: './scheme-wise-route-popup.component.html',
})
export class SchemeWiseRoutePopupComponent {
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeDialog: EventEmitter<any> = new EventEmitter<any>();
  @Input() displayDialog: boolean = false;
  
  shareType: string | null = null;
  selectedUser: any; // For single selection (edit)
  selectedUsers: any[] = []; // For multiple selection (view/comment)
  selectedUnits: any[] = []; // For multiple selection (external view/comment)
  unitList: any[] = []; // For multiple selection (external view/comment)
  permissionType: string | null = null;
  selectedUnit: any;
  internalComment:string
  externalComment:string
  selectedCommand: any=null;
  isFinalApproval: boolean = false;
  resetForm() {
    this.shareType = null;
    this.selectedUser = null;
    this.selectedUsers = [];
    this.selectedUnits = [];
    this.permissionType = 'edit';
    this.isFinalApproval = false;
    this.selectedUnit = null;
    this.internalComment = '';
    this.externalComment = '';
    this.selectedCommand = null;
  }
    isLoading: boolean = false;


    constructor(private api: ApiService, private messageService: MessageService) {
      // this.getCammandList();
      this.openDialog();
    }

    commandList:any[]=[]
    getCammandList(){
      this.api.getAPI(`/master/commands/`).subscribe((res: any) => {
        this.commandList = res.data;
      });
    }

    openDialog() {
      this.displayDialog = true;
      this.getUserListForRouteConfig();
      this.getUnitForRouteConfig()
      this.getCammandList()
      this.resetForm();
    }
    userList:any
    getUserListForRouteConfig() {
    const unitId = Number(sessionStorage.getItem('unit_id'));
   this.api.getAPI('/account/users/?unit_id='+unitId).subscribe((res: any) => {
    this.userList = res.data;
    });
  }
  getUnitForRouteConfig() {
    let currentUnitId  = sessionStorage.getItem('unit_id');
   this.api.getAPI('/master/units/').subscribe((res: any) => {
     this.unitList = res.data.filter((u: any) => u.id != Number(currentUnitId));
   })
  }

  signatureData:any
  addSignature(){
    const currentUser = sessionStorage.getItem('user_id');
    this.signatureData=this.userList.find((user: any) => user.id == currentUser);
    const comment = this.signatureData;
    const qrText = `Electronically Signed by: ${comment.created_by?.first_name} ${comment.created_by?.last_name} | 
      Rank: ${comment.created_by?.rankName || 'N/A'} | 
      Directorate: ${comment.unit?.name || 'N/A'} | 
      Designation: ${comment.created_by?.hrcdf_designation || 'N/A'}`;
  
    this.generateQRCode(qrText).then(url => {
      this.signatureData.qr_code = url;
    }).catch(err => {
      console.error('QR Code generation failed', err);
    });
  }
  generateQRCode(text: string): Promise<string> {
    return QRCode.toDataURL(text);
  }

  submitShare() {
    this.isLoading = true;
    const payload: any = {
      user: this.selectedUser?.id,
      is_final_editor: this.isFinalApproval,
      shareType:this.shareType,permissionType:this.permissionType,selectedUser:this.selectedUser,selectedUsers:this.selectedUsers,selectedUnits:this.selectedUnits,selectedUnit:this.selectedUnit,internalComment:this.internalComment,externalComment:this.externalComment,selectedCommand:this.selectedCommand
    };
    this.onSubmit.emit(payload);
    this.closeDialog.emit();
    this.isLoading = false;
  }
}
